import { render, staticRenderFns } from "./breadcrumb.component.vue?vue&type=template&id=0af5af4c&scoped=true&"
import script from "./breadcrumb.component.vue?vue&type=script&lang=ts&"
export * from "./breadcrumb.component.vue?vue&type=script&lang=ts&"
import style0 from "./breadcrumb.component.vue?vue&type=style&index=0&id=0af5af4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af5af4c",
  null
  
)

export default component.exports